import React from 'react';
import { C } from 'shared/helpers';
import PropTypes from 'prop-types';

import Styles from './MobileLoginBar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser, faLock } from '@fortawesome/free-solid-svg-icons';

import { Input, Button } from 'components/Template';

export default function MobileLoginBar({
  email,
  password,
  inputChangeHandler,
  submitHandler,
  open,
  setOpen,
  authError,
}) {
  const { MobileLoginBar, Open, Header, Close, Container } = Styles;
  return (
    <form onSubmit={submitHandler} className={C(MobileLoginBar, [open, Open])}>
      <div className={C(Header, Container)}>
        <div id='login_bar_mobile_close_btn'>
          <FontAwesomeIcon
            onClick={() => setOpen(false)}
            className={Close}
            icon={faTimes}
          />
        </div>
        <Input
          type='email'
          name='email'
          onChange={inputChangeHandler}
          containerClassName={Styles.input}
          placeholder='E-mail'
          icon={faUser}
          value={email}
        />
        <p style={{ display: !authError ? 'none' : 'block', color: 'red' }}>
          {authError}
        </p>
        <p style={{ display: authError ? 'none' : 'block' }}>
          NÃO TEM CADASTRO?
        </p>{' '}
      </div>
      <div className={C(Header, Container)}>
        <Input
          name='password'
          onChange={inputChangeHandler}
          containerClassName={Styles.input}
          placeholder='Senha'
          type='password'
          icon={faLock}
          value={password}
        />
        <p style={{ fontWeight: '600' }}>ESQUECEU A SENHA?</p>
      </div>
      <div className={Styles.SubmitContainer}>
        <Button
          disabled={false}
          color='success'
          onClick={submitHandler}
          className={Styles.button}
        >
          Entrar
        </Button>
      </div>
    </form>
  );
}

MobileLoginBar.defaultProps = {
  authError: null,
};

MobileLoginBar.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  inputChangeHandler: PropTypes.func.isRequired,
  submitHandler: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  authError: PropTypes.string,
};
